import styled from "styled-components";

export const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 36px;
`

export const Icon = styled.div`
  margin: 0 15px;
  width: 36px;
  height: 36px;
  
  img {
    width: 100%;
    height: auto;
  }

  @media (min-width: 980px) {
    margin: 0 30px;
    width: auto;
    height: auto;

    img {
      width: auto;
      height: auto;
    }
  }
`